import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-texteditor',
  templateUrl: './texteditor.component.html',
  styleUrls: ['./texteditor.component.scss']
})
export class TexteditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
